import React from 'react';
import PropTypes from 'prop-types';
class ChipView extends React.PureComponent {
    static propTypes = {
        children: PropTypes.element,
        content: PropTypes.any,
    };

    render() {
        const { children, content } = this.props;
        const childrenWithProps = React.Children.map(children, child => React.cloneElement(child, { content }));

        return [childrenWithProps];
    }
}

export default ChipView;
